import React from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Grid,
	Radio,
	RadioGroup,
	TextField,
} from "@mui/material";
import { formatDateTimeEs } from "../../utils/formatters";

export const SincronizarTrabajadoresDialog = ({
	open,
	onClose,
	syncing,
	syncMode,
	onSyncModeChange,
	desde,
	onDesdeChange,
	hasta,
	onHastaChange,
	onSubmit,
	hoyYMD,
}) => {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
			<DialogTitle>Sincronizar trabajadores</DialogTitle>
			<DialogContent>
				<RadioGroup value={syncMode} onChange={(event) => onSyncModeChange(event.target.value)}>
					<FormControlLabel
						value="hoy"
						control={<Radio />}
						label={`Solo hoy (${formatDateTimeEs(hoyYMD, { includeTime: false })})`}
					/>
					<FormControlLabel value="rango" control={<Radio />} label="Rango de fechas" />
				</RadioGroup>

				{syncMode === "rango" && (
					<Grid container spacing={2} sx={{ mt: 1 }}>
						<Grid item xs={6}>
							<TextField
								label="Desde"
								type="date"
								size="small"
								fullWidth
								value={desde}
								onChange={(event) => onDesdeChange(event.target.value)}
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Hasta"
								type="date"
								size="small"
								fullWidth
								value={hasta}
								onChange={(event) => onHastaChange(event.target.value)}
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
					</Grid>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={syncing}>
					Cancelar
				</Button>
				<Button variant="contained" onClick={onSubmit} disabled={syncing}>
					Sincronizar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
